import React, { useState, useEffect } from 'react';
import { getAllProgrammes, createProgramme, updateProgramme, deleteProgramme } from '../../services/api';

const ProgrammeSection = () => {
  const [grille, setGrille] = useState([]);
  const [loading, setLoading] = useState(true);
  const joursSemaine = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

  useEffect(() => { fetchProgrammes(); }, []);

  const fetchProgrammes = async () => {
    try {
      const response = await getAllProgrammes();
      const formattedData = response.data.map(item => ({
        ...item,
        desc: item.description || "" 
      }));
      setGrille(formattedData);
    } catch (error) { console.error(error); } finally { setLoading(false); }
  };

  const handleChange = (index, field, value) => {
    const newGrille = [...grille];
    newGrille[index][field] = value;
    setGrille(newGrille);
  };

  const handleAddEmission = async () => {
    const newEntry = { jour: "Lundi", heure: "00:00 - 00:00", titre: "Nouveau Programme", animateur: "Nom", description: "" };
    try { await createProgramme(newEntry); fetchProgrammes(); } catch (error) { alert("Erreur lors de l'ajout"); }
  };

  const handleDeleteEmission = async (id, index) => {
    if (!id) {
      setGrille(grille.filter((_, i) => i !== index));
      return;
    }
    if (window.confirm("Supprimer définitivement cette émission ?")) {
      try {
        await deleteProgramme(id);
        setGrille(grille.filter(item => item.id !== id));
      } catch (error) { alert("Erreur lors de la suppression"); }
    }
  };

  const handleSaveAll = async () => {
    try {
      const promises = grille.map(item => {
        const dataToSend = {
          jour: item.jour,
          heure: item.heure,
          titre: item.titre,
          animateur: item.animateur,
          description: item.desc
        };
        return updateProgramme(item.id, dataToSend);
      });
      await Promise.all(promises);
      alert("Grille mise à jour !");
      fetchProgrammes();
    } catch (error) { alert("Erreur lors de la sauvegarde"); }
  };

  if (loading) return <div className="text-center p-5"><div className="spinner-border text-warning"></div></div>;

  return (
    <div className="bg-secondary bg-opacity-10 p-3 p-md-4 rounded-5 border border-secondary border-opacity-25 fade-in">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 gap-3">
        <h4 className="fw-black text-uppercase m-0">Gestion de la Grille</h4>
        <div className="d-flex gap-2 w-100 w-md-auto">
          <button onClick={handleAddEmission} className="btn btn-outline-info fw-black px-3 rounded-pill btn-sm flex-grow-1">
            + AJOUTER
          </button>
          <button onClick={handleSaveAll} className="btn btn-warning fw-black px-3 rounded-pill btn-sm flex-grow-1">
            ENREGISTRER TOUT
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-dark table-hover align-middle border-secondary" style={{ minWidth: '800px' }}>
          <thead>
            <tr className="text-muted small text-uppercase">
              <th>Jour</th>
              <th>Horaire</th>
              <th>Émission</th>
              <th>Animateur</th>
              <th>Description</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {grille.map((item, index) => (
              <tr key={item.id || index}>
                <td>
                  <select className="form-select form-select-sm bg-dark text-info border-secondary shadow-none fw-bold" value={item.jour} onChange={(e) => handleChange(index, 'jour', e.target.value)}>
                    {joursSemaine.map(j => <option key={j} value={j}>{j}</option>)}
                  </select>
                </td>
                <td><input type="text" className="form-control form-control-sm bg-dark text-white border-secondary" value={item.heure} onChange={(e) => handleChange(index, 'heure', e.target.value)} /></td>
                <td><input type="text" className="form-control form-control-sm bg-dark text-white border-secondary fw-bold" value={item.titre} onChange={(e) => handleChange(index, 'titre', e.target.value)} /></td>
                <td><input type="text" className="form-control form-control-sm bg-dark text-warning border-secondary" value={item.animateur} onChange={(e) => handleChange(index, 'animateur', e.target.value)} /></td>
                <td><textarea className="form-control form-control-sm bg-dark text-white border-secondary" rows="1" value={item.desc} onChange={(e) => handleChange(index, 'desc', e.target.value)} /></td>
                <td className="text-center">
                  <button onClick={() => handleDeleteEmission(item.id, index)} className="btn btn-outline-danger btn-sm border-0"><i className="bi bi-trash3-fill"></i></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProgrammeSection;